<template>
  <v-container fluid class="pa-4">
    <v-card class="elevation-2">
      <v-toolbar color="blue-grey darken-2" dark dense>
        <v-icon left>account_balance</v-icon>
        <v-toolbar-title>Kasa (Ana Kasa — Boşta)</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Ara (ürün / seri)"
          single-line
          hide-details
          clearable
          dark
          style="max-width: 280px"
        ></v-text-field>
        <v-btn icon class="ml-2" :loading="loading" @click="load">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <div class="inv-hint">
          Zimmeti kimsede olmayan, ana kasada boştaki ürünler. (Ziynet/Külçe: toplam − tüm zimmetler; Takı: kimseye zimmetli olmayan envanterdeki seriler.)
        </div>

        <v-layout wrap class="inv-stats">
          <v-flex xs6 sm3 class="pr-2">
            <div class="inv-stat inv-stat--teal">
              <div class="inv-stat-label">Takı</div>
              <div class="inv-stat-value">{{ qtyByType(0) }} <span class="inv-stat-unit">adet</span></div>
            </div>
          </v-flex>
          <v-flex xs6 sm3 class="pr-2">
            <div class="inv-stat inv-stat--amber">
              <div class="inv-stat-label">Ziynet</div>
              <div class="inv-stat-value">{{ qtyByType(1) }} <span class="inv-stat-unit">adet</span></div>
            </div>
          </v-flex>
          <v-flex xs6 sm3 class="pr-2">
            <div class="inv-stat inv-stat--grey">
              <div class="inv-stat-label">Külçe</div>
              <div class="inv-stat-value">{{ qtyByType(2) }} <span class="inv-stat-unit">adet</span></div>
            </div>
          </v-flex>
          <v-flex xs6 sm3>
            <div class="inv-stat inv-stat--purple">
              <div class="inv-stat-label">Toplam Kalem</div>
              <div class="inv-stat-value">{{ lines.length }}</div>
            </div>
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headers"
          :items="filteredLines"
          :loading="loading"
          :rows-per-page-items="[50, 100, 500, { text: 'Tümü', value: -1 }]"
          class="elevation-0 kasa-table"
        >
          <template v-slot:items="props">
            <td class="px-2">
              <span class="inv-chip" :class="typeChipClass(props.item.inventoryType)">
                {{ props.item.inventoryTypeName }}
              </span>
            </td>
            <td class="px-2 kasa-name">{{ props.item.productName }}</td>
            <td class="px-2">{{ props.item.weight }}</td>
            <td class="px-2">{{ props.item.purityLabel }}</td>
            <td class="px-2">{{ props.item.size || '-' }}</td>
            <td class="px-2 kasa-mono">{{ props.item.serialNumber || '-' }}</td>
            <td class="px-2 text-xs-right kasa-qty">{{ props.item.quantity }}</td>
          </template>
          <template v-slot:no-data>
            <div class="inv-empty">
              <v-icon large color="grey lighten-1">account_balance</v-icon>
              <div>Ana kasada boşta ürün yok (tümü zimmetli).</div>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    lines: [],
    search: "",
    headers: [
      { text: "Tip", value: "inventoryTypeName" },
      { text: "Ürün", value: "productName" },
      { text: "Ağırlık", value: "weight" },
      { text: "Ayar", value: "purityLabel" },
      { text: "Ölçü", value: "size" },
      { text: "Seri No", value: "serialNumber" },
      { text: "Boşta Adet", value: "quantity", align: "right" },
    ],
  }),

  computed: {
    filteredLines() {
      const q = (this.search || "").toLocaleLowerCase("tr");
      if (!q) return this.lines;
      return this.lines.filter(l =>
        [l.productName, l.serialNumber, l.inventoryTypeName, l.purityLabel]
          .filter(Boolean)
          .some(v => v.toLocaleLowerCase("tr").includes(q))
      );
    },
  },

  created() {
    this.load();
  },

  methods: {
    typeChipClass(t) {
      if (t === 0) return "inv-chip--teal";
      if (t === 1) return "inv-chip--wait";
      return "inv-chip--grey";
    },
    qtyByType(t) {
      return this.lines.filter(l => l.inventoryType === t).reduce((s, l) => s + (l.quantity || 0), 0);
    },
    async load() {
      this.loading = true;
      try {
        this.lines = (await this.$store.dispatch("inventory/getKasa")) || [];
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message =
          "Kasa yüklenemedi: " +
          ((e && e.response && e.response.data && e.response.data.message) || (e && e.message) || "");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.kasa-table {
  border: 1px solid #e5e9f0;
  border-radius: 8px;
}
.kasa-table >>> thead th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #90a4ae;
  font-weight: 600;
}
.kasa-table >>> tbody tr:hover {
  background: #f6f8f9;
}
.kasa-name {
  font-weight: 600;
  color: #263238;
}
.kasa-mono {
  font-family: Menlo, Consolas, monospace;
  font-size: 12px;
  color: #546e7a;
}
.kasa-qty {
  font-family: Menlo, Consolas, monospace;
  font-size: 14px;
  font-weight: 700;
  color: #37474f;
}
</style>
